import { State } from 'app/redux';

export const isThumbnailVisible = (state: State) => state.thumbnail.show;
export const getImageUrl = (state: State) => state.thumbnail.imageUrl;
